import { constants } from "../constants";

export const setFeatureFlags = (flags) => ({
  type: constants.SET_FEATURE_FLAGS,
  payload: flags
});
